<template>
    <div class="form-group ">
        <label :for="name" v-if="!hideLabel">{{label}}</label>

        <b-form-file v-model="file" :placeholder="placeholder" @input="handleFileUpload"/>

        <a :href="value" class="download-link">{{value}}</a>
        <div v-if="errors.has(name)" class="invalid-feedback">
            {{errors.first(name)}}
        </div>
    </div>
</template>

<script>
    import mixinField from '../../mixins/mixinField';

    export default {

        mixins: [mixinField],
        name: "FieldUpload",
        props:['link'],
        data() {
            return {
                file: null,
                rules: "",
                url: ""
            }
        },

        methods: {
            handleFileUpload() {

                if (this.file) {
                    let formData = new FormData();

                    formData.append('file', this.file);
                    //'/fa/v1/downloads/upload-file'
                    this.axios.post(this.link, formData, {
                        headers: {'Content-Type': 'multipart/form-data'}
                    }).then(({data}) => {

                        this.$emit('input', data.data.url)

                    }).catch(() => {


                    });
                }

            }
        }

    }
</script>

<style scoped>

    .download-link {
        display: block;
        padding-top: 15px;
        text-align: left;
    }

</style>


// WEBPACK FOOTER //
// src/components/fields/FieldUpload.vue